// List companies
export const GET_COMPANIES = `${BACKOFFICE_API_URL}/companies`
// Get all company comments: grade, product and normal comments
export const GET_COMMENTS = `${BACKOFFICE_API_URL}/companies/:id/comments`
export const CREATE_COMMENT = `${BACKOFFICE_API_URL}/companies/:id/comments`

// Get single company using crn
export const GET_COMPANY = `${BACKOFFICE_API_URL}/companies/:id`

export const GET_COMPANY_CHECKS = `${BACKOFFICE_API_URL}/companies/:id/checks`
export const POST_COMPANY_CHECKS = `${BACKOFFICE_API_URL}/companies/:id/checks`

export const GET_COMPANY_BANK_DETAILS = `${BACKOFFICE_API_URL}/companies/:id/bank-accounts`

// Products
export const GET_COMPANY_PRODUCTS = `${BACKOFFICE_API_URL}/companies/:id/products`
export const UPDATE_COMPANY_PRODUCTS = `${BACKOFFICE_API_URL}/companies/:id/products/:product_id`
export const OVERRIDE_ETP_FINANCING_INDICATOR = `${BACKOFFICE_API_URL}/companies/:id/financing-indicator`

// Bank accounts
export const BANK_ACCOUNTS = `${BACKOFFICE_API_URL}/companies/:id/bank-accounts`
export const CREATE_BANK_ACCOUNT = `${BACKOFFICE_API_URL}/companies/:id/bank-accounts`
export const UPDATE_BANK_ACCOUNT = `${BACKOFFICE_API_URL}/companies/:id/bank-accounts/:bank_account_id`

// Suspend companies
export const SUSPEND_COMPANY = `${BACKOFFICE_API_URL}/companies/:id/suspend`
export const UNSUSPEND_COMPANY = `${BACKOFFICE_API_URL}/companies/:id/unsuspend`

// Edit or override company fields
export const EDIT_COMPANY = `${BACKOFFICE_API_URL}/companies/:id`
